// extracted by mini-css-extract-plugin
export default {"heading":"qk-z","list":"rk-z"};